import { useState } from "react";
import ArrowLeft from "../../../../assets/icons/ArrowLeft";
import Cross from "../../../../assets/icons/Cross";
import { Activity, MeetupsTableItemType } from "../../../../types";
import DefaultButton from "../../../default-button/DefaultButton";
import { accessGlobalMiscState } from "../../../../stores/misc";
import InputField from "../../../input-field/InputField";
import { showSnackbar } from "../../../../misc/utils";
import { simpleGetter } from "../../../../actions/common";
import { activitiesApi } from "../../../../api/api";

type Props = {
  setIsRejectModalOpen: (value: boolean) => void;
};

export default function MeetupsRejectModal({
  setIsRejectModalOpen,
}: Props) {
  const [input, changeInput] = useState("");
  const currentMeet: Activity = accessGlobalMiscState().get('meetupsFormEditItem');

  const onReject = async () => {
    const response = await simpleGetter(activitiesApi.rejectActivity, { id: currentMeet.id, comment: input });
    showSnackbar(
      response.success ? "Успешно" : "Произошла ошибка",
      response.success ? "success" : "error"
    );
    if (response.success) {
      accessGlobalMiscState().setBatch({
        activitiesTriggerFetch: (accessGlobalMiscState().get("activitiesTriggerFetch") || 0) + 1,
        isMeetupsRejectModalOpen: false
      })
    }
  }

  return (
    <div className="w-fit p-8 rounded-xl bg-white text-black absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col">
      <div>
        <div
          onClick={() => setIsRejectModalOpen(false)}
          className="flex justify-end cursor-pointer"
        >
          <Cross additionalStyle="text-[#5F6B88]" />
        </div>
        <p className="font-normal text-[15px] text-[#5F6B88]">
          Отклонить мероприятие
        </p>
        <p className="text-black font-normal text-[24px]">
          {currentMeet?.name}
        </p>
      </div>
      <div className="flex-grow mt-8">
        <p className="font-medium text-[15px] text-[#5F6B88]">Комментарий*</p>
        <InputField
          type="textarea"
          value={input}
          handleChange={(e) => changeInput(e.target.value)}
          additionalClassName="bg-[#F0F3FA] w-full resize-none outline-none rounded-lg px-4 py-3 mt-2"
        />
      </div>
      <div className="grid grid-cols-[5fr_7fr] gap-3 mt-4">
        <DefaultButton
          buttonText="Вернуться"
          additionalStyle="bg-[#5F6B88] text-white px-8 py-3 text-nowrap"
          Icon={ArrowLeft}
          onClick={() => setIsRejectModalOpen(false)}
        />
        <DefaultButton
          buttonText="Отклонить мероприятие"
          additionalStyle="bg-[#F12D2D] text-white px-8 py-3 text-nowrap"
          Icon={Cross}
          onClick={onReject}
        />
      </div>
    </div>
  );
}
